/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';
import { Filter } from '../../../model/Filter';

class AlarmViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, authenticationService, alarmService, alarmSourceService, siteService, equipmentService,
        equipmentTemplateService, alarmCodeService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, $scope, dialogService, filterService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.authenticationService = authenticationService;
        this.alarmService = alarmService;
        this.alarmSourceService = alarmSourceService;
        this.siteService = siteService;
        this.equipmentService = equipmentService;
        this.equipmentTemplateService = equipmentTemplateService;
        this.alarmCodeService = alarmCodeService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$log.debug('Controller \'AlarmView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.alarmsDisabled = true;
        this.alarmSources = [];
        this.sites = [];
        this.equipments = [];
        this.alarmCodes = [];

        this.title = 'ui.alarm.creation';

        this.handleRestServiceCall(this.$q.all({
            alarmSources: this.alarmSourceService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'}),
                data: this.filterService.buildFilters([Filter.equalFilter('system', false)])
            }),
            sites: this.siteService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            })
        }), data => {
                this.pristineEntity = {};
                this.alarmSources = data.alarmSources;
                this.sites = data.sites;
                if (this.alarmSources.length === 1) {
                    this.pristineEntity.sourceId = this.alarmSources[0].id;
                }
                this.reset();
            }
        ).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Loads equipments in a site.
     *
     * @param {Number} siteId Site ID.
     */
    loadEquipments(siteId) {
        if (siteId) {
            this.equipmentsDisabled = true;
            this.handleRestServiceCall(
                this.getEquipments(siteId),
                equipments => this.equipments = equipments
            ).catch(() => {
                this.notificationService.pushMessage('ui.alarm.equipmentloadingfailed',
                    this.configuration.NOTIFIER_LEVEL_ERROR);
            }).finally(() => {
                this.equipmentsDisabled = false;
            });
        }
    }

    /**
     * Gets equipments in a site.
     *
     * @param {Number} siteId Site ID.
     * @return {Promise} Promise containing the equipments loaded.
     */
    getEquipments(siteId) {
        return this.equipmentService.findEntities({
            params: this.filterService.buildSortingParam({sort: 'name'}),
            data: this.filterService.buildFilters([Filter.equalFilter('site.id', siteId)])
        });
    }

    /**
     * Loads alarm codes granted for an equipment.
     *
     * @param {object} [equipment] Equipment.
     */
    loadAlarmCodes(equipment) {
        if (equipment) {
            this.alarmCodesDisabled = true;
            this.alarm.equipmentId = equipment.id;
            this.handleRestServiceCall(
                this.equipmentTemplateService.getEntity(equipment.equipmentTemplateId).then(
                    equipmentTemplate => {
                        return this.alarmCodeService.findEntities({
                            params: this.filterService.buildSortingParam({sort: 'label'}),
                            data: this.filterService.buildFilters([
                                Filter.equalFilter('id', equipmentTemplate.alarmCodeIds)
                            ])
                        });
                    }
                ),
                alarmCodes => {
                    this.alarmCodes = alarmCodes;
                }
            ).catch(() => {
                this.notificationService.pushMessage('ui.alarm.alarmcodeloadingfailed',
                    this.configuration.NOTIFIER_LEVEL_ERROR);
            }).finally(() => {
                this.alarmCodesDisabled = false;
            });
        }
    }

    save() {
        this.formDisabled = true;
        return this.handleRestServiceCall(this.alarmService.createEntity(this.alarm), () => {
            this.notificationService.pushMessage('ui.alarm.created', this.configuration.NOTIFIER_LEVEL_INFO);
            this.showActionRequestNavigationDialog();
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    /**
     * Shows a prompt dialog to know whether the user wants to create an action request (if the user is an admin, or was
     * granted the expected role). If the dialog is confirmed, the new state is the action request creation view.
     * Otherwise, the new state is the list of alarms.
     */
    showActionRequestNavigationDialog() {
        if (this.authenticationService.userHasRole(['ADMIN', 'ACTION_REQUEST_CREATE'])) {
            this.dialogService.showConfirmationDialogWithData({
                titleKey: 'ui.alarm.createactionrequest',
                messageKey: 'ui.alarm.requestaction',
                confirmKey: 'ui.button.yes',
                cancelKey: 'ui.button.no'
            }).then(confirmed => {
                this.$state.go(confirmed ? 'gmao.actionrequest.create' : 'gmao.alarm.list', {
                    equipmentId: this.alarm.equipmentId
                });
            });
        }
    }

    /**
     * Restores the initial state of the view, and the map.
     */
    reset() {
        this.alarm = angular.copy(this.pristineEntity);
    }
}

export const alarmViewComponent = {
    template: require('./alarm-view.html'),
    controller: AlarmViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmView.js